import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IBookingCreatorSetting } from './types';

const NS = 'bookingCreatorSettingSlice';

const initialState: IBookingCreatorSetting = {
  isWideVersion: false,
  isUseRecurringNewVersion: false,
  isEnableUpdateDetect: false,
};

const bookingCreatorSettingSlice = createSlice({
  name: 'bookingCreatorSetting', // used in action types
  initialState,
  reducers: {
    /**
     * This function is only for diary when use booking creator on wide viewpoint
     */
    setWideVersion: (state: IBookingCreatorSetting, action: PayloadAction<boolean>) => {
      state.isWideVersion = action.payload;
    },
    setIsEnableUpdateDetect: (state: IBookingCreatorSetting, action: PayloadAction<boolean>) => {
      state.isEnableUpdateDetect = action.payload;
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = bookingCreatorSettingSlice;
// Extract and export each action creator by name
export { actions as bookingCreatorSettingActions };
// Export the reducer, either as a default or named export
export default reducer;
